import numeral from 'numeral'
import store from '@/store/store'

export function formatNumber (number: number, formatString: string = '0,0') {
    return numeral(number).format(formatString)
}

export function formatOrdinal (number: number, formatString: string = '0,0o') {
    return formatNumber(number, formatString)
}

export function formatNumberTo3SD (number: number) {
    return numeral(number.toPrecision(3)).format('0[.][00]a')
}

export function formatCurrency (cents: number, options?: {
    symbol?: string,
    showCents?: boolean,
}) {
    const optionsToUse = {
        symbol: store.getters['account/currencySymbol'],
        showCents: true,
        ...(options || {}),
    }
    const { symbol, showCents } = optionsToUse

    const formatString = showCents ? '0,0.00' : '0,0'

    return `${cents < 0 ? '– ' : ''}${symbol || ''}${numeral(Math.abs(cents / 100)).format(formatString)}`
}
